import { useState, useEffect } from "react";
import { isAdmin } from "../../../util/helpers";

function useUserMediaStatus() {
  const [userMediaEnabled, setUserMediaEnabled] = useState(true);

  useEffect(() => {
    const checkUserMediaStatus = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        stream.getTracks().forEach((track) => track.stop());
        setUserMediaEnabled(true);
      } catch (error) {
        setUserMediaEnabled(false);
      }
    };

    if(!isAdmin()) checkUserMediaStatus();
  }, []);

  return userMediaEnabled;
}

export default useUserMediaStatus;